import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  alert,
  tokens,
  twofa,
  profile,
  linkRole
} from "../components/CustomComponent.js";
import Turnstile from "react-turnstile";
import LOGOLARGE from "../assets/images/logo512.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      password_view: "password",
      remember: false,
      token: "",
      captchaKey: Date.now(),
    };
    this.turnstileRef = createRef();
  }
  async componentDidMount() {
    if (tokens) {
      const result = await GET("v1/market/profile");
      if (result?.status) {
        window.location.href = `/main`;
      }
    }
    loading(false);
  }

  Login = async () => {
    const { token, email, password, remember } = this.state;
    if (!token) {
      alert("", "warning", "Warning", "Please confirm CAPTCHA.");
      return;
    }
    loading(true);
    let result = await POST("v1/public/market/login", {
      email: email,
      password: btoa(password),
      remember: remember,
      token: token,
    });
    if (result?.status) {
      localStorage.setItem("scp-acc-tk", btoa("Bearer " + result.data.token));
      localStorage.setItem(
        "scp-profile",
        JSON.stringify({
          ...result.data,
          password: "",
          verify_time: new Date(new Date().setMinutes(new Date().getMinutes() + 10)).getTime(),
        })
      );
        window.location.href = "/main";
    } else{
      this.setState({ token: "", captchaKey: Date.now() });
    }
    loading(false);
  };

  render() {
    const { email, password, password_view, token } =
      this.state;
    return !tokens ? (
      <div className="w-100 min-vh-100 bg-orange position-relative">
        <div className="row w-100 mx-0 min-vh-100 d-flex align-items-center">
            <div className="col-11 col-md-10 col-lg-6 col-xl-4 mx-auto my-5">
              <div className="bg-light rounded-4 shadow px-3 py-4">
                <h3 className="fw-bold text-dark mb-3">เข้าสู่ระบบ</h3>
                <div className="text-secondary mb-3">ติดตามสถานะสินค้าและสั่งซื้อได้ง่ายในที่เดียว</div>
              <label className="mb-1">ชื่อผู้ใช้</label>
              <input
                className="form-control mb-3"
                type="text"
                placeholder="ชื่อผู้ใช้"
                onChange={(e) => {
                  this.setState({ email: e.target.value });
                }}
                value={email}
              />
              <label className="mb-1">รหัสผ่าน</label>
              <div className="position-relative">
                <input
                  className="form-control mb-3"
                  type={password_view}
                  placeholder="รหัสผ่าน"
                  onChange={(e) => {
                    this.setState({ password: e.target.value });
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      this.Login();
                    }
                  }}
                  value={password}
                />
                <div
                  className="wpx-40 hpx-40 d-flex justify-content-center align-items-center icon pointer position-absolute"
                  style={{ right: 0, top: -2 }}
                  onClick={() => {
                    this.setState({
                      password_view:
                        password_view === "password" ? "text" : "password",
                    });
                  }}
                >
                  {password_view === "password" ? "\uf06e" : "\uf070"}
                </div>
              </div>
              <div className="w-100 mb-2">
                <Turnstile
                  key={this.state.captchaKey}
                  size="flexible"
                  sitekey={process.env.REACT_APP_CLOUDFLARE_SITE_KEY}
                  onVerify={(token) => {
                    this.setState({ token });
                  }}
                  onExpire={() => {
                    this.setState({ token: "" });
                  }}
                />
              </div>
              <button
                type="button"
                className={`btn ${
                  token ? "btn-dark" : "btn-secondary"
                } w-100 mb-3`}
                onClick={() => {
                  this.Login();
                }}
                disabled={!token}
              >
                เข้าสู่ระบบ
              </button>
              <p className="text-center mb-3">ยังไม่มีบัญชีใช่หรือไม่?  
                <a href="/register" className="text-decoration-none text-orange text-nowrap text-14 mx-1">สมัครสมาชิก</a>
                </p>
              <p className="text-center mb-3">การเข้าสู่ระบบแสดงว่าคุณยอมรับ 
                <a href="/policy-privacy" className="text-decoration-none text-orange text-nowrap text-14 mx-1">เงื่อนไขการใช้งาน</a>
                และ
                <a href="/policy-privacy" className="text-decoration-none text-orange text-nowrap text-14 mx-1">นโยบายความเป็นส่วนตัว</a>
                </p>
                <div className="text-center">
                  <a href="/" className="text-secondary text-nowrap text-14 mx-1">ย้อนกลับ</a>
                </div>
              </div>
            </div>
        </div> 
      </div>
    ) : (
      <div></div>
    );
  }
}
